import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { i18n, mediaQueryMax, useGetAdmins } from "src/common";
import { ContainerComponent, StepHeader, Text, Card, Flex, StarRating } from "src/components";
import { colors } from "src/theme";

const Image = styled.img<{ ml?: number }>`
  width: 50px;
  height: 50px;
  border: 1px solid var(--Border-Border-7, ${colors.background7});
  background: ${colors.background7};
  border-radius: 50%;
  box-shadow: 0px 4px 4px 0px #00000014;
  margin-left: ${({ ml = 0 }) => ml}px;
  object-fit: cover;

  ${mediaQueryMax('mobile')} {
    width: 40px;
    height: 40px;
    margin-left: ${({ ml = 0 }) => ml}px;
  }
`;

export const ContactWebshopPage = () => {
  const { data } = useGetAdmins();

  return (
    <ContainerComponent>
      <Helmet>
        <title>Kontakt ostvaren | Osiguranje imovine - kompare.hr</title>
      </Helmet>
      <StepHeader/>
      <Card padding="24px 8px">
        <Flex vertical gap={24}>
          <Flex vertical gap={24} style={{ padding: '8px'}}>
            <Text type="xLarge" bold>{i18n.t('pages.steps.contactWebshop')}</Text>
            <Text type="sMedium" color={colors.text3}>{i18n.t('pages.steps.contactWebshopSubtitle')}</Text>
          </Flex>
          <Flex align="center" gap={12}>
            { data?.map((d, i) => (
              <Image ml={i > 0 ? -24 : 0} src={d.avatar || ""} />
            ))            
            }
            <Flex vertical>
              <StarRating rating={4.7} />
              <Flex gap={4}>
                <Text type="small" bold>143.833</Text>
                <Text type="small">zadovoljnih kupaca</Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </ContainerComponent>
  );
};
